import axios, { AxiosPromise } from 'axios';

const BASE_URL = '/gateway/api/verificacao-documentos';

export const documentoValidacaoNivel = (): AxiosPromise<any[]> =>
  axios.get(`${BASE_URL}/documento-validacao-nivel`);

export const minhaSolicitacao = (): AxiosPromise<any> =>
  axios.get(`${BASE_URL}/usuario-solicitacao`);

export const isHabilitado = (): AxiosPromise<boolean> =>
  axios.get(`${BASE_URL}/habilitado`);

export const enviarSolicitacao = (
  dto: any,
  files: File[]
): AxiosPromise<any> => {
  const formData = new FormData();
  formData.append(
    'dto',
    new Blob([JSON.stringify(dto)], { type: 'application/json' })
  );
  files.forEach(file => formData.append('files', file));

  return axios.post(`${BASE_URL}/usuario-solicitacao`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const reenviarDocumentos = (
  dtos: any[],
  files: File[]
): AxiosPromise<any[]> => {
  const formData = new FormData();
  formData.append(
    'dtos',
    new Blob([JSON.stringify(dtos)], { type: 'application/json' })
  );
  files.forEach(file => formData.append('file', file));

  return axios.put(`${BASE_URL}/usuario-documentos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
